import script from "./ResultsDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultsDisplay.vue?vue&type=script&setup=true&lang=js"

import "./ResultsDisplay.vue?vue&type=style&index=0&id=a9a4d9ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9a4d9ec"]])

export default __exports__